


















































import {
  defineComponent,
  ref,
  computed,
  onMounted,
  nextTick,
  PropType,
} from '@vue/composition-api';
import { formatContractName } from '@/views_v2/pre-apply-choose/utils';
import { ContractContentTypeEnum } from '@/api/middle-income/types';
import type { ContractItemDetail } from '@/api/middle-income/types';
import { Tabs, TabItem as Tab } from '@hb/coffee';

type ContractViewItem = ContractItemDetail & { icon?: string };

/**
 * 获取协议 iframe URL（处理 PDF 和普通协议）
 * @param url 协议地址
 * @param contentType 内容类型
 */
const getContractIframeUrl = (url: string, contentType?: ContractContentTypeEnum): string => {
  if (!url) {
    return '';
  }
  // 如果是 PDF 类型（contentType === ContractContentTypeEnum.PDF），使用 PDF 预览器
  if (contentType === ContractContentTypeEnum.PDF || url.toLowerCase().endsWith('.pdf')) {
    const contractsUrl = process.env.VUE_APP_CONTRACTS_URL || '';
    return `${contractsUrl}?pdf_url=${url}`;
  }
  return url;
};

export default defineComponent({
  components: {
    Tabs,
    Tab,
  },
  name: 'ContractViewWithTab',
  props: {
    /** 协议列表 */
    contractList: {
      type: Array as PropType<ContractViewItem[]>,
      required: true,
      default: () => [],
    },
    /** 协议展示区域高度（单位：vm），默认自适应 */
    contractHeight: {
      type: Number,
      default: 0,
    },
    /** 初始选中的协议索引 */
    initialIndex: {
      type: Number,
      default: 0,
    },
  },
  emits: ['change-contract'],
  setup(props, { emit }) {
    const contractListRef = ref<HTMLDivElement | null>(null);
    const contractShowRef = ref<HTMLDivElement | null>(null);

    /** 当前选中的协议索引 */
    const activeContractIndex = ref(props.initialIndex);

    /** 当前选中的协议 URL */
    const currentIframeUrl = computed(() => {
      if (!props.contractList || props.contractList.length === 0) {
        return '';
      }
      const currentContract = props.contractList[activeContractIndex.value];
      if (!currentContract) {
        return '';
      }
      const url = currentContract.url || '';
      return getContractIframeUrl(url, currentContract.type);
    });

    /**
     * 切换协议
     * @param index 协议索引
     */
    const onChangeContract = (index: number) => {
      if (index === activeContractIndex.value) {
        return;
      }
      activeContractIndex.value = index;
      const currentContract = props.contractList[index];
      emit('change-contract', {
        index,
        contract: currentContract,
      });
    };

    const onClickTab = (payload: unknown) => {
      if (typeof payload === 'number') {
        onChangeContract(payload);
        return;
      }
      if (payload && typeof payload === 'object') {
        const maybeAny = payload as { name?: unknown; index?: unknown };
        const rawIndex = maybeAny.name != null ? maybeAny.name : maybeAny.index;
        const parsedIndex = typeof rawIndex === 'number' ? rawIndex : Number(rawIndex);
        if (!Number.isNaN(parsedIndex)) {
          onChangeContract(parsedIndex);
        }
      }
    };

    /**
     * 设置协议展示区初始化高度
     */
    const setContractShowInitHeight = () => {
      if (contractShowRef.value && props.contractHeight === 0) {
        // 如果没有指定高度，则固定当前高度
        // contractShowRef.value.style.height = `${contractShowRef.value.clientHeight}px`;
        // contractShowRef.value.style.flex = 'none';
      }
    };

    onMounted(() => {
      nextTick(() => {
        setContractShowInitHeight();
      });
    });

    return {
      contractListRef,
      contractShowRef,
      activeContractIndex,
      currentIframeUrl,
      onClickTab,
      formatContractName,
    };
  },
});
